import * as z from "zod";
import {
  hsaReconciliationCsvOutputSchema,
  hsaReconciliationDateSchema,
} from "./hsa-reconciliation-common";

/** Gale's Transactions CSV export (includes customer emails). Same access as `getHsaTransactions`. */
export const exportHsaTransactionsCsv = {
  name: "exportHsaTransactionsCsv" as const,
  input: z.object({
    dateFrom: hsaReconciliationDateSchema.optional(),
    dateTo: hsaReconciliationDateSchema.optional(),
  }),
  output: hsaReconciliationCsvOutputSchema,
};
